<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Image</h3>
    </template>
    <template slot="body">
      <div>
        <img v-bind:src="imgUrl" >
      </div>
      <div>
        <input id="file" type="file" style="display: none;" @change="upload" multiple/>
        <div class="upload_area">
          <a href="#" class="upload_bt" @click="AC_fileClick()">Upload</a>
        </div>
      </div>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {uploadProdTypeImg} from "@/api/document";
import $ from "jquery";

export default {
  components: {
    CommonModal ,
  },
  data() {
    return {
      imgUrl:'',
      form : {
        prodId : '',
        file : ''
      },
    };
  },
  methods: {
    async fetchData(prodId){
      this.form.prodId = prodId;
      this.imgUrl = "/mgmt/prodType/img/" +  prodId + "?" + new Date().getTime();
    },
    async upload(event) {

      let formData = new FormData();
      formData.append('file', event.target.files[0]);
      formData.append('prodId', this.form.prodId);

      try {
        const response = await uploadProdTypeImg(formData);
        await this.fetchData(this.form.prodId);
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    AC_fileClick() {
      $('#file').click();
    }
  }
}
</script>

<style>
</style>